module.exports = __webpack_public_path__ + "img/gallery8.5eba39f.jpg";